import React, { useState } from "react";
import { Box, Button, InputLabel, Stack, TextField } from "@mui/material";
import { EventCategories } from "../../Models/EventCategoriesModel.ts";
import { addOrUpdateEventCategory } from "../../Requests/EventCategoriesService.ts";


export default function AddEventCategory(props: any) {

  const [name, setName] = useState<string>("")

  const handlePublish = async () => {
    let object = new EventCategories()
    object.name = name
    await addOrUpdateEventCategory(object)
    props.publish()
  }

  return (
    <>
      <Box>
        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Category name"}</InputLabel>
          <TextField
            placeholder="Category name"
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </Stack>
      </Box>

      <Box
        display="flex"
        justifyContent="right"
        marginTop={4}
      >
        <Button
          variant="contained"
          size="large"
          onClick={() => handlePublish()}
        >
          {"Publish"}
        </Button>
      </Box>
    </>
  )
}
